import { noop } from '../noop.js';
import { hasProp } from '../props.js';
import { conf } from './conf.js';
import { reusable } from './convincely.js';
const higherSync = (src, dest) => {
    let data;
    while ((data = src.shift())) {
        dest.push(data);
    }
};
const tealiumHigherSync = (src, dest) => {
    let data;
    while ((data = src.shift())) {
        dest.link(data);
    }
};
class AnalyticsService {
    constructor() {
        this._dataLayer = reusable('_dataLayer', [], conf.$appName);
        this._syncCallback = higherSync;
        this.missingDataLayer = false;
        const ga = (this._ga = (...args) => {
            ga.data.push(args);
        });
        ga.data = [];
        this.checkDataLayer();
    }
    checkDataLayer() {
        setTimeout(() => {
            if (!window.dataLayer) {
                this.missingDataLayer = true;
            }
        }, 3000);
    }
    get dataLayer() {
        return this.sync(this._dataLayer, window.dataLayer);
    }
    get ga() {
        return this.sync(this._ga, window.ga, (src, dest) => {
            let args;
            if (!this.gaId && window.gaData) {
                this.gaId = Object.keys(window.gaData)[0];
                dest('create', this.gaId, 'auto');
            }
            while ((args = src.data.shift())) {
                dest(...args);
            }
        });
    }
    sync(src, dest, cb = this._syncCallback) {
        if (dest) {
            cb(src, dest);
        }
        return dest || src;
    }
    track({ _page, data, event = 'trackStep', key, step, value }) {
        const dataPush = { event };
        if (_page) {
            dataPush._page = _page;
        }
        if (data) {
            if (hasProp(data, 'branch') && !data.branch) {
                delete data.branch;
            }
            if (hasProp(data, 'variantSuffix')) {
                data.variant = `${data.variant}${data.variantSuffix}`;
                delete data.variantSuffix;
            }
            Object.assign(dataPush, data);
        }
        if (step) {
            Object.assign(dataPush, { step });
        }
        if (key && value) {
            Object.assign(dataPush, { _page: [key, value].join('_') });
        }
        else if (key && !value) {
            Object.assign(dataPush, { _page: key });
        }
        else if (!key && value) {
            Object.assign(dataPush, { _page: value });
        }
        this.dataLayer.push(dataPush);
        /* test-code */
        // eslint-disable-next-line no-console
        console.log('analyticsService.track', dataPush);
        /* end-test-code */
    }
}
class TealiumAnalyticsService extends AnalyticsService {
    constructor({ prefix = 'convincely_', category = 'ConvincelyFunnel', section = 'convincely', uid = [] }) {
        super();
        this._syncCallback = tealiumHigherSync;
        this._prefix = prefix;
        this._category = category;
        this._section = section;
        this._uid = Array.isArray(uid) ? uid : uid.length ? uid.replace(/\s/g, '').split(',') : [];
        this._defaultEvent = 'click';
        this._defaultAction = 'Click';
        this._eventMap = {
            virtualPageview: 'pageview',
            FunnelLoad: 'funnelload',
            FunnelOpen: 'funnelopen',
            FunnelWidgetView: 'funnelwidgetview',
            trackStep: 'click',
        };
        this._actionMap = {
            virtualPageview: 'virtualPageview',
            FunnelLoad: 'FunnelLoad',
            FunnelOpen: 'FunnelOpen',
            FunnelWidgetView: 'FunnelWidgetView',
            trackStep: 'Click',
        };
    }
    checkDataLayer() {
        setTimeout(() => {
            if (!window.utag) {
                this.missingDataLayer = true;
            }
        }, 3000);
    }
    get dataLayer() {
        return this.sync(this._dataLayer, window.utag);
    }
    track({ _page, data, event = 'trackStep', key, step, value }) {
        const tealiumEvent = this._eventMap[event] || this._defaultEvent;
        const dataPush = {
            tealium_event: `${this._prefix}${tealiumEvent}`,
            [`${this._prefix}event`]: event,
            event_category: this._category,
            event_action: this._actionMap[event] || this._defaultAction,
        };
        if (_page) {
            dataPush[`${this.prefix}page`] = _page;
        }
        if (data) {
            if (hasProp(data, 'branch') && !data.branch) {
                delete data.branch;
            }
            try {
                Object.keys(data).forEach((k) => {
                    Object.assign(dataPush, { [this._prefix + k]: data[k] });
                });
            }
            catch (e) {
                //
            }
        }
        if (step) {
            dataPush[`${this._prefix}step`] = step;
        }
        if (key && value) {
            Object.assign(dataPush, { [`${this._prefix}page`]: [key, value].join('_') });
        }
        else if (key && !value) {
            Object.assign(dataPush, { [`${this._prefix}page`]: key });
        }
        else if (!key && value) {
            Object.assign(dataPush, { [`${this._prefix}page`]: value });
        }
        try {
            this.dataLayer.link(dataPush, noop, this._uid);
        }
        catch (e) {
            this.dataLayer.push(dataPush);
        }
        /* test-code */
        // eslint-disable-next-line no-console
        (conf.isLocal || conf.isDev) && console.log('analyticsService.track', dataPush);
        /* end-test-code */
    }
}
export let analyticsService = reusable('analyticsService', new AnalyticsService(), conf.$appName);
export const updateAnalyticsService = (provider, props = {}) => {
    if (provider === 'tealium') {
        analyticsService = new TealiumAnalyticsService(props);
    }
};
//# sourceMappingURL=analytics.js.map